import { v4 } from 'uuid';
import { CheckoutBuilderComponentTypes, CheckoutBuilderDeviceTypes, lightThemeValues } from './index';

export const defaultValuesDesktop = {
  settings: {
    ...lightThemeValues,
  },
  extra: {
    exitPopup: {
      id: v4(),
      type: CheckoutBuilderComponentTypes.exitPopup.id,
      attributes: CheckoutBuilderComponentTypes.exitPopup.attributes,
    },
    notification: {
      id: v4(),
      type: CheckoutBuilderComponentTypes.notification.id,
      attributes: CheckoutBuilderComponentTypes.notification.attributes,
    },
    chat: {
      id: v4(),
      type: CheckoutBuilderComponentTypes.chat.id,
      attributes: CheckoutBuilderComponentTypes.chat.attributes,
    },
  },
  rows: [
    {
      id: v4(),
      layout: [12],
      type: 'row',
      columns: [
        {
          id: v4(),
          type: 'column',
          components: [],
        },
      ],
    },
    {
      id: v4(),
      layout: [12],
      type: 'row',
      columns: [
        {
          id: v4(),
          type: 'column',
          components: [
            {
              id: v4(),
              type: CheckoutBuilderComponentTypes.checkout.id,
              attributes: CheckoutBuilderComponentTypes.checkout.attributes,
            },
          ],
        },
        {
          id: v4(),
          type: 'column',
          components: [],
        },
      ],
    },
  ],
};

export const defaultValuesMobile = {
  settings: {
    ...lightThemeValues,
  },
  extra: {
    exitPopup: {
      id: v4(),
      type: CheckoutBuilderComponentTypes.exitPopup.id,
      attributes: CheckoutBuilderComponentTypes.exitPopup.attributes,
    },
    notification: {
      id: v4(),
      type: CheckoutBuilderComponentTypes.notification.id,
      attributes: CheckoutBuilderComponentTypes.notification.attributes,
    },
    chat: {
      id: v4(),
      type: CheckoutBuilderComponentTypes.chat.id,
      attributes: CheckoutBuilderComponentTypes.chat.attributes,
    },
  },
  rows: [
    {
      id: v4(),
      layout: [12],
      type: 'row',
      columns: [
        {
          id: v4(),
          type: 'column',
          components: [],
        },
      ],
    },
    {
      id: v4(),
      layout: [12],
      type: 'row',
      columns: [
        {
          id: v4(),
          type: 'column',
          components: [
            {
              id: v4(),
              type: CheckoutBuilderComponentTypes.checkout.id,
              attributes: CheckoutBuilderComponentTypes.checkout.attributes,
            },
          ],
        },
      ],
    },
  ],
};

export const defaultCheckoutConfig = {
  device: CheckoutBuilderDeviceTypes.desktop.id,
  desktop: defaultValuesDesktop,
  mobile: defaultValuesMobile,
};
